export default function initFixedHeader() {
	const headerStatic = document.querySelector('.header-fixed');
	if (!headerStatic) return;

    const headerHeight = headerStatic.getBoundingClientRect().height;
    const headerFixed = headerStatic.cloneNode(true);
    headerFixed.classList.add('_hidden');
    headerStatic.after(headerFixed);

    const stickyHead = function (entries) {
        const [entry] = entries;
        if (!entry.isIntersecting) {
            headerFixed.classList.remove('_hidden');
            headerFixed.classList.add('_fix');
        } else {
            headerFixed.classList.add('_hidden');
            headerFixed.classList.remove('_fix');
        }
    };
    const options = {
        root: null,
        threshold: [1],
        rootMargin: `${headerHeight * 3}px`,
    };
    const sectionObserver = new IntersectionObserver(stickyHead, options);
    sectionObserver.observe(headerStatic);
}
